import type { IExercise } from '../exercises';

export const ARCHIVED_BACK_TEACHINGS: IExercise[] = [
  {
    "id": "incline-bench-row",
    "name": "上斜凳坐姿划船",
    "bodyPart": "back",
    "equipment": "machine",
    "subCategory": "thickness",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["斜方肌中下部","菱形肌","背阔肌"],
    "demoUrl": "/media/gifs/incline-bench-row",
    "videoUrl": "/media/videos/incline-bench-row",
  },
  {
    "id": "wall-scapular-protraction",
    "name": "靠墙单臂肩胛前引",
    "bodyPart": "back",
    "equipment": "bodyweight",
    "subCategory": "width",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "每侧10",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["背阔肌","大圆肌"],
    "demoUrl": "/media/gifs/wall-scapular-protraction",
    "videoUrl": "/media/videos/wall-scapular-protraction",
  },
  {
    "id": "home-prone-back-extension",
    "name": "俯卧背伸",
    "bodyPart": "back",
    "equipment": "bodyweight",
    "subCategory": "width",
    "tips": ["核心收紧，控制动作节奏","全程保持稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["背阔肌","大圆肌"],
    "demoUrl": "/media/gifs/home-prone-back-extension",
    "videoUrl": "/media/videos/home-prone-back-extension",
  },
  {
    "id": "home-single-arm-dumbbell-row",
    "name": "单臂哑铃划船",
    "bodyPart": "back",
    "equipment": "dumbbell",
    "subCategory": "thickness",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "每侧10-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["斜方肌中下部","菱形肌","背阔肌"],
    "demoUrl": "/media/gifs/home-single-arm-dumbbell-row",
    "videoUrl": "/media/videos/home-single-arm-dumbbell-row",
  },
  {
    "id": "home-double-dumbbell-bent-row",
    "name": "双哑铃俯身划船",
    "bodyPart": "back",
    "equipment": "dumbbell",
    "subCategory": "thickness",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["斜方肌中下部","菱形肌","背阔肌"],
    "demoUrl": "/media/gifs/home-double-dumbbell-bent-row",
    "videoUrl": "/media/videos/home-double-dumbbell-bent-row",
  },
  {
    "id": "home-pull-up",
    "name": "引体向上",
    "bodyPart": "back",
    "equipment": "bodyweight",
    "subCategory": "width",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "力竭",
    "rpe": 9,
    "restSeconds": 75,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["背阔肌","大圆肌"],
    "demoUrl": "/media/gifs/home-pull-up",
    "videoUrl": "/media/videos/home-pull-up",
  },
  {
    "id": "ksw-warmup-lower-trap-y",
    "name": "下斜方激活Y字",
    "bodyPart": "back",
    "equipment": "bodyweight",
    "subCategory": "激活",
    "tips": ["俯身成Y字，拇指朝上抬臂","感受下斜方肌收紧，沉肩不耸肩"],
    "sets": 2,
    "reps": "15",
    "rpe": 3,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-lower-trap-y",
    "videoUrl": "/media/videos/ksw-warmup-lower-trap-y",
  },
  {
    "id": "ksw-single-arm-cable-pulldown",
    "name": "单手钢线下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["单手持把手，挺胸沉肩","下压时感受背阔肌收缩，顶峰停顿 1 秒"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["背阔肌","大圆肌"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-single-arm-cable-pulldown",
    "videoUrl": "/media/videos/ksw-single-arm-cable-pulldown",
  },
  {
    "id": "ksw-single-arm-machine-row",
    "name": "单手器械划船",
    "bodyPart": "back",
    "equipment": "machine",
    "subCategory": "row",
    "tips": ["单手对握把手，身体稳定不晃动","拉至腰侧，感受中背收缩"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["斜方肌中下部","菱形肌","背阔肌"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-single-arm-machine-row",
    "videoUrl": "/media/videos/ksw-single-arm-machine-row",
  },
  {
    "id": "ksw-wide-grip-row",
    "name": "开肘拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "rear-delt",
    "tips": ["开肘位绳索划船，侧重后束和中背","拉至下巴位置，肩胛骨充分后缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌后束","斜方肌"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-wide-grip-row",
    "videoUrl": "/media/videos/ksw-wide-grip-row",
  },
  {
    "id": "threeway-back-warmup",
    "name": "背部热身",
    "bodyPart": "back",
    "equipment": "bodyweight",
    "subCategory": "full-body",
    "tips": ["激活背阔肌和菱形肌","每组15次"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/videos/threeway-back-warmup",
    "videoUrl": "/media/videos/threeway-back-warmup",
  },
  {
    "id": "threeway-neutral-pulldown",
    "name": "对握高位下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["拉至胸上沿","挤压背阔肌"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-neutral-pulldown",
    "videoUrl": "/media/videos/threeway-neutral-pulldown",
  },
  {
    "id": "threeway-supinated-pulldown",
    "name": "反手高位下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["反手握距较窄","二头协同发力"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-supinated-pulldown",
    "videoUrl": "/media/videos/threeway-supinated-pulldown",
  },
  {
    "id": "threeway-narrow-cable-row",
    "name": "窄距对握划船",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "row",
    "tips": ["拉至下腹部","肩胛骨后缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-narrow-cable-row",
    "videoUrl": "/media/videos/threeway-narrow-cable-row",
  },
  {
    "id": "threeway-tbar-row",
    "name": "T杆划船",
    "bodyPart": "back",
    "equipment": "barbell",
    "subCategory": "row",
    "tips": ["核心稳定不晃","拉至髋部"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-tbar-row",
    "videoUrl": "/media/videos/threeway-tbar-row",
  },
  {
    "id": "threeway-bent-barbell-row",
    "name": "俯身杠铃提拉",
    "bodyPart": "back",
    "equipment": "barbell",
    "subCategory": "row",
    "tips": ["俯身角度45度","杠铃沿小腿向上提拉"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-bent-barbell-row",
    "videoUrl": "/media/videos/threeway-bent-barbell-row",
  },
  {
    "id": "personal-s1-rhomboid-stretch",
    "name": "菱形肌拉伸",
    "bodyPart": "back",
    "equipment": "bodyweight",
    "subCategory": "back",
    "tips": ["含胸沉肩，感受中背拉伸","保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-rhomboid-stretch",
    "videoUrl": "/media/videos/personal-s1-rhomboid-stretch",
  },
  {
    "id": "personal-s2-straight-arm-pulldown",
    "name": "直臂下压",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lats",
    "tips": ["核心收紧，背部主导发力","感受背阔肌延展与收缩"],
    "sets": 3,
    "reps": "12",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s2-straight-arm-pulldown",
    "videoUrl": "/media/videos/personal-s2-straight-arm-pulldown",
  },
  {
    "id": "personal-s2-single-arm-cable-row",
    "name": "单手绳索划船",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lats",
    "tips": ["肩胛后收再拉肘","每侧交替感受背阔肌收缩"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s2-single-arm-cable-row",
    "videoUrl": "/media/videos/personal-s2-single-arm-cable-row",
  },
  {
    "id": "fanjue-scapular-activation",
    "name": "凳上肩胛骨激活",
    "bodyPart": "back",
    "equipment": "bodyweight",
    "subCategory": "thoracic",
    "tips": ["肩胛前引后缩","控制动作节奏"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-scapular-activation",
    "videoUrl": "/media/videos/fanjue-scapular-activation",
  },
  {
    "id": "fanjue-wide-pulldown",
    "name": "宽握高位下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["宽握距更大程度拉伸背阔","拉至锁骨位置"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-wide-pulldown",
    "videoUrl": "/media/videos/fanjue-wide-pulldown",
  },
  {
    "id": "fanjue-prone-machine-row",
    "name": "俯身器械划船",
    "bodyPart": "back",
    "equipment": "machine",
    "subCategory": "row",
    "tips": ["胸贴凳面","拉至下腹部"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-prone-machine-row",
    "videoUrl": "/media/videos/fanjue-prone-machine-row",
  },
  {
    "id": "fanjue-seated-machine-row",
    "name": "坐姿器械划船",
    "bodyPart": "back",
    "equipment": "machine",
    "subCategory": "row",
    "tips": ["背部挺直","肩胛后缩挤压"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-seated-machine-row",
    "videoUrl": "/media/videos/fanjue-seated-machine-row",
  },
  {
    "id": "fanjue-lat-pulldown",
    "name": "高位下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["沉肩下拉","感受背阔收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-lat-pulldown",
    "videoUrl": "/media/videos/fanjue-lat-pulldown",
  },
  {
    "id": "fanjue-seated-cable-row",
    "name": "坐姿绳索划船",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "row",
    "tips": ["躯干保持稳定","拉至小腹位置"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-seated-cable-row",
    "videoUrl": "/media/videos/fanjue-seated-cable-row",
  },
];
